// ✅ leadSlice.ts
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteLead, fetchAllLeads, Lead } from "../../../api/lead";

// 🔁 Unique state interface
interface ReduxReLeadsState {
  reduxReLeadsList: Lead[];
  reduxReLeadsLoading: boolean;
  reduxReLeadsError: string | null;
}

const initialState: ReduxReLeadsState = {
  reduxReLeadsList: [],
  reduxReLeadsLoading: false,
  reduxReLeadsError: null,
};

// ✅ Fetch Leads Thunk
export const fetchReduxReLeadsThunk = createAsyncThunk(
  "reduxReLeads/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchAllLeads();
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch leads");
    }
  }
);

// ✅ Delete Lead Thunk
export const deleteReduxReLeadThunk = createAsyncThunk(
  "reduxReLeads/delete",
  async (leadId: string, { rejectWithValue }) => {
    try {
      await deleteLead(leadId);
      return leadId;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to delete lead");
    }
  }
);

// ✅ Slice Definition
const reduxReLeadsSlice = createSlice({
  name: "reduxReLeads",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetch leads
      .addCase(fetchReduxReLeadsThunk.pending, (state) => {
        state.reduxReLeadsLoading = true;
        state.reduxReLeadsError = null;
      })
      .addCase(fetchReduxReLeadsThunk.fulfilled, (state, action) => {
        state.reduxReLeadsLoading = false;
        state.reduxReLeadsList = action.payload;
      })
      .addCase(fetchReduxReLeadsThunk.rejected, (state, action) => {
        state.reduxReLeadsLoading = false;
        state.reduxReLeadsError = action.payload as string;
      })

      // delete lead
      .addCase(deleteReduxReLeadThunk.fulfilled, (state, action) => {
        state.reduxReLeadsList = state.reduxReLeadsList.filter(
          (lead) => lead.lead_id !== action.payload
        );
      })
      .addCase(deleteReduxReLeadThunk.rejected, (state, action) => {
        state.reduxReLeadsError = action.payload as string;
      });
  },
});

export default reduxReLeadsSlice.reducer;
